import { Dropdown } from '@sunwebgroup/ui-components/uds'
import get from 'lodash/get'
import { useController, useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import { useStatus } from '@/scopes/common/components/FormElements/useStatus'

interface DropdownInputProps {
  items: { value: string, text: string }[]
  label?: string
  name: string
  required?: boolean
  requiredErrorMessage?: string
  formFieldClass?: string
  placeholder?: string
  disabled?: boolean
  helpText?: string
}

export function DropdownInput({
  items,
  label,
  name,
  required,
  requiredErrorMessage,
  formFieldClass,
  placeholder,
  disabled,
  helpText,
}: DropdownInputProps) {
  const intl = useIntl()
  const {
    control,
    formState,
  } = useFormContext()
  const status = useStatus({
    name,
    required,
  })

  const { defaultValues } = formState
  const defaultValue = get(defaultValues, name)
  const { field: {
    value,
    onChange,
    onBlur,
    disabled: fieldDisabled,
  } } = useController({
    name,
    control,
    disabled,
    rules: {
      required,
    },
  })

  return (
    <Dropdown.Root
      name={name}
      value={value}
      onValueChange={onChange}
      disabled={fieldDisabled}
      defaultValue={defaultValue}
    >
      <Dropdown.Trigger
        placeholder={placeholder}
        onBlur={onBlur}
        label={label}
        feedbackText={requiredErrorMessage}
        status={status}
        formFieldClass={formFieldClass}
        optionalLabel={!required ? intl.formatMessage({ id: 'common_form_field_optional_label' }) : undefined}
        helpText={helpText}
      />
      <Dropdown.Content>
        {items.map(({ text, value }) => (
          <Dropdown.Item value={value} key={`${name}${text}`}>{text}</Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown.Root>
  )
}
